import _ from 'lodash';
import React, { Component } from 'react';
import * as CLIntF from '../../../interfaces/classroomLessons';
import StudentStatic from '../../classroomLessons/play/static';
import PromptField from './slideComponents/promptField';
import SlidePreview from './slideComponents/slidePreview';
import TitleField from './slideComponents/titleField';

interface CustomizeStaticProps {
  question: CLIntF.QuestionData,
  updateQuestion: Function,
  clearSlide: Function,
  resetSlide: Function,
  questionIndex: number,
  incompletePrompt: Boolean
}

class CustomizeStatic extends Component<CustomizeStaticProps, {}>{
  constructor(props){
    super(props);

    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)
    this.handleHTMLChange = this.handleHTMLChange.bind(this)
  }

  updateQuestion(newVals, questionIndex) {
    this.props.updateQuestion(newVals, questionIndex)
  }

  handleTitleChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'teach.title', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleHTMLChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.html', e)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  render() {
    const { clearSlide, questionIndex, resetSlide, question, incompletePrompt, } = this.props

    return (
      <div className="slide">
        <div className="form">
          <TitleField
            clearSlide={clearSlide}
            handleTitleChange={this.handleTitleChange}
            questionIndex={questionIndex}
            resetSlide={resetSlide}
            title={question.teach.title}
          />
          <PromptField
            handleTextChange={(e) => this.handleHTMLChange(e)}
            incompletePrompt={incompletePrompt}
            questionIndex={questionIndex}
            reset={question.reset}
            showBlockquote={true}
            text={question.play.html}
          />
        </div>
        <SlidePreview slideNumber={questionIndex}>
          <StudentStatic data={question} />
        </SlidePreview>
      </div>
    )
  }

}

export default CustomizeStatic
